export default __webpack_public_path__ + "static/bg-81cb30bca7f309faa88841b76573b758.webp";